import { ContextLog } from 'constants/contextLog';
import { loggerInfo } from 'utils/infoLog';
import { getUserInfo } from 'utils/user';

const track = (context: ContextLog, title: string, properties?: any) => {
	const userInfo = getUserInfo();
	properties = {
		...properties,
		project: 'companies',
		distinct_id: userInfo.id || '',
	};
	loggerInfo({
		data: { ...userInfo, properties: properties },
		context,
		type: 'info',
	});
};

const Analytics = {
	track,
};

export default Analytics;
